import script from "./TheNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNavBar.vue?vue&type=script&setup=true&lang=js"

import "./TheNavBar.vue?vue&type=style&index=0&id=8d964e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d964e5e"]])

export default __exports__